import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../../../services/media-query.service';
import { SecurityService } from '../../../../services/security.service';
import { MenuService } from '../../../../services/menu/menu.service';
import { MenuPanelItem } from '../../../../domain/menu.domain';
import { DataAnalyticsTaggingService } from '../../../../features/data-analytics-tagging/data-analytics-tagging.service';
import { DataAnalyticsTaggingConstants } from '../../../../features/data-analytics-tagging/data-analytics-tagging.constants';
import { IconComponent } from '../../../../components/icon/icon.component';

@Component({
  selector: 'td-wb-menu-toolbar',
  templateUrl: 'menu-toolbar.component.html',
  styleUrls: ['menu-toolbar.component.scss'],
  imports: [
    NgClass,
    IconComponent,
    TranslateDirective
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuToolbarComponent implements OnInit, OnDestroy {

  toolbarLabelsVisible: boolean;
  isDesktop: boolean = true;
  breakpointChangesSubscription: Subscription;

  constructor(private menuService: MenuService,
              private mediaQueryService: MediaQueryService,
              private changeDetectorRef: ChangeDetectorRef,
              private securityService: SecurityService,
              private dataAnalyticsTaggingService: DataAnalyticsTaggingService) {
  }

  ngOnInit(): void {
    this.breakpointChangesSubscription = this.mediaQueryService.observe(Breakpoint.GT_LG)
      .subscribe((state: BreakpointState): void => {
        this.isDesktop = state.matches;
        this.changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    if (this.breakpointChangesSubscription !== undefined) {
      this.breakpointChangesSubscription.unsubscribe();
    }
  }

  // TODO:: Remove this method once API is changed
  removeIconPrefix(iconId: string): string {
    return iconId.replace('td-wb-icon--', '');
  }

  getUtilityToolbar(): Array<MenuPanelItem> {
    return this.menuService.getUtilityToolbar(this.isDesktop);
  }

  hasSearchBar(): boolean {
    return this.securityService.hasPermission('SEARCH');
  }

  onMenuClick(utility: MenuPanelItem): void{
    this.dataAnalyticsTaggingService.emitTaggingEvent(DataAnalyticsTaggingConstants.getLinkClickEventData(`tdw:et:quicklinks:${utility.text}`));
  }
}
